export default __webpack_public_path__ + "static/media/entry-point.0c55e9a9.png";